<template>
  <div>
    <!-- 礼包中心弹窗 -->
    <GiftDialog ref="dialog" @refreshActivatedGame="refreshActivatedGame"></GiftDialog>
    <TopHeader headerTitle="已激活游戏" :isShowMenuIcon="false" />
    <div :class="$style.line"></div>
    <div :class="$style.box">
      <section :class="$style['game-info']">
        <img :src="activatedGameInfo.images" />
        <p>{{ activatedGameInfo.name }}</p>
        <p>礼包数{{ activatedGameInfo.count }}</p>
      </section>
      <section :class="$style.tab">
        <button
          :class="[$style['tab-btn'], isActive ? $style.active : '']"
          @click="handleNormalTab"
        >
          全民礼包
        </button>
        <button :class="[$style['tab-btn'], !isActive ? $style.active : '']" @click="handleVipTab">
          VIP礼包
        </button>
      </section>
      <section :class="$style['gift-list']">
        <!-- 全民礼包 -->
        <div
          v-if="tabType === 'common'"
          :class="$style['gift-block']"
          :key="item.id"
          v-for="item of activatedGiftList"
        >
          <!-- 板块名 -->
          <div :class="$style['gift-title']">{{ item.name }}</div>
          <!-- 礼包列表 -->
          <div
            v-for="m of item.gift_sets"
            :key="m.id"
            :class="$style['gift-item']"
            @click="handleLinkTo('giftCenter.details', { giftId: m.id })"
          >
            <div>
              <p>{{ m.title }}</p>
              <p>{{ m.description }}</p>
            </div>
            <button v-if="m.can_get == 1" @click.stop="handleReceiveGift(m)">领取</button>
            <button v-else style="background-color: #9d9d9d" @click.stop="alreadyReceivedGift">
              已领取
            </button>
          </div>
        </div>

        <!-- vip 礼包 -->
        <div
          v-if="tabType === 'vip'"
          v-for="item of activatedGiftList"
          :key="item.id"
          :class="$style['gift-item']"
          @click="handleLinkTo('giftCenter.details', { giftId: item.id })"
        >
          <div>
            <p>{{ item.title }}</p>
            <p>{{ item.description }}</p>
          </div>
          <button v-if="item.can_get == 1" @click.stop="handleReceiveGift(item)">领取</button>
          <button v-else style="background-color: #9d9d9d" @click.stop="alreadyReceivedGift">
            已领取
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import TopHeader from '_c/TopHeader';
import GiftDialog from './components/GiftDialog';
import { getActivatedGameDetail } from '@/api/giftCenter';
import { reportData } from '@/api/report';
import { mapState, mapMutations, mapActions } from 'vuex';
import { CDN_URL } from '@/config/index.js';
export default {
  data() {
    return {
      activatedGameInfo: {}, // 已激活游戏礼包信息
      activatedGiftList: [], // 礼包列表
      isActive: true,
      tabType: 'common', //点击的tab类型（common, vip）
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo,
    }),
  },
  components: {
    TopHeader,
    GiftDialog,
  },
  created() {
    this.getActivatedGameDetail();
  },
  methods: {
    ...mapMutations('giftCenter', {
      SHOW_GIFT_DIALOG: 'SHOW_GIFT_DIALOG',
      SET_GIFT_ITEM: 'SET_GIFT_ITEM',
    }),
    async getActivatedGameDetail() {
      const r = await getActivatedGameDetail({ game_id: this.$route.query.gameId });
      this.activatedGameInfo = { ...r.data };
      if (this.tabType === 'common') {
        this.activatedGiftList = [...this.activatedGameInfo.common];
      } else {
        this.activatedGiftList = [...this.activatedGameInfo.vip];
      }
    },
    handleNormalTab() {
      reportData({
        type: 10,
        data_type: 2,
      });
      this.tabType = 'common';
      this.isActive = !this.isActive;
      this.activatedGiftList = [...this.activatedGameInfo.common];
    },
    handleVipTab() {
      reportData({
        type: 10,
        data_type: 3,
      });
      this.tabType = 'vip';
      this.isActive = !this.isActive;
      this.activatedGiftList = [...this.activatedGameInfo.vip];
    },
    // 路由跳转
    handleLinkTo(name, query) {
      this.$router.push({ name, query });
    },
    // 打开领取礼包弹窗
    handleReceiveGift(item) {
      this.SHOW_GIFT_DIALOG(true);
      this.SET_GIFT_ITEM(item);
    },
    // 点击已领取按钮
    alreadyReceivedGift() {
      this.$refs.dialog.showNormalDialog('receivedGift');
    },
    // 刷新页面
    refreshActivatedGame() {
      this.getActivatedGameDetail();
    },
  },
};
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
@import '~@/styles/variable.scss';
.line {
  width: 100%;
  height: 1px;
  background-color: #efefef;
}
.box {
  padding-bottom: 20px;
  width: 100%;
  height: calc(100vh - 44px);
  overflow-y: auto;
  .game-info {
    width: 100%;
    height: 118px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 58px;
      height: 58px;
    }
    p:nth-child(2) {
      margin-top: 7px;
      font-size: 10px;
    }
    p:nth-child(3) {
      margin-top: 7px;
      font-size: 8px;
      color: rgb(255, 126, 48);
    }
  }
  .tab {
    display: flex;
    justify-content: center;
    width: 100%;
    .tab-btn {
      @include clearBtnDefaultStyle;
      width: 146px;
      height: 32px;
      box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.03);
      border-radius: 5px;
      font-size: 10px;
      color: #888686;
      border: 1px solid #efefef;
      background-color: #fafafa;
    }
    .active {
      color: #ff7e30;
      background-color: #ffffff;
    }
  }
  .gift-list {
    width: 100%;

    .gift-block {
      margin-top: 20px;
    }

    .gift-title {
      margin-left: 30px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .gift-title::before {
      content: ' ';
      display: inline-block;
      width: 4px;
      height: 12px;
      margin-right: 4px;
      background: rgba(253, 146, 90, 1);
      border-radius: 2px;
    }

    .gift-item {
      padding: 18px 25px 14px 30px;
      width: 100%;
      height: 73px;
      display: flex;
      @include border-bottom-1px;
      div {
        margin-right: 6px;
        width: 85%;
        line-height: 12.5px;
        p:nth-child(1) {
          margin-bottom: 5px;
          font-size: 11px;
        }
        p:nth-child(2) {
          font-size: 10px;
          color: #acacac;
        }
      }
      button {
        @include clearBtnDefaultStyle;
        padding: 0;
        margin-top: 10px;
        width: $buttonWidth;
        height: $buttonHeight;
        color: #fff;
        font-size: 10px;
        background-color: $buttonColor;
        border-radius: 15px;
      }
    }
  }
}
.loadingStyle {
  position: absolute;
  z-index: 99999;
  top: 45%;
  width: 100%;
  height: 30px;
  text-align: center;
  color: rgba(159, 159, 159, 1);
}
</style>
